var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-wrapper"},[(_vm.url && !_vm.$apollo.loading)?_c('iframe',{style:({ width: '100%', height: '100%'}),attrs:{"src":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }